module.exports = __webpack_public_path__ + "img/35.04e18c2d.png";